<template>
    <v-card :loading="form.busy || loading" mx-4 min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-tabs
            v-model="tab"
            background-color="primary"
            dark
        >
            <v-tab key="company">
                Date companie
            </v-tab>
            <v-tab key="settings">
                Diverse Setari
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item key="company">
                <v-card class="px-4 py-4" flat>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                v-model="form.name"
                                v-validate="'required'"
                                :error-messages="errorMessages('name')"
                                :class="{ 'error--text': hasErrors('name') }"
                                class="primary--text"
                                name="name"
                                label="Denumire"
                                data-vv-name="name"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-row>
                                <v-col cols="4">
                                    <v-text-field
                                        v-model="form.data.company_vat"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('company_vat')"
                                        :class="{ 'error--text': hasErrors('company_vat') }"
                                        class="primary--text"
                                        name="company_vat"
                                        label="CUI (Cod Unic de Identificare)"
                                        data-vv-name="company_vat"
                                        counter="255"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field
                                        v-model="form.data.company_regcom"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('company_regcom')"
                                        :class="{ 'error--text': hasErrors('company_regcom') }"
                                        class="primary--text"
                                        name="company_regcom"
                                        label="Numarul Registrul Comertului"
                                        data-vv-name="company_regcom"
                                        counter="255"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field
                                        v-model="form.data.company_authorization"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('company_authorization')"
                                        :class="{ 'error--text': hasErrors('company_authorization') }"
                                        class="primary--text"
                                        name="Numar autorizatie"
                                        label="Numar autorizatie"
                                        data-vv-name="company_authorization"
                                        counter="255"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.company_county"
                                v-validate="'required'"
                                :error-messages="errorMessages('company_county')"
                                :class="{ 'error--text': hasErrors('company_county') }"
                                class="primary--text"
                                name="company_county"
                                label="Judet"
                                data-vv-name="company_county"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.company_city"
                                v-validate="'required'"
                                :error-messages="errorMessages('company_city')"
                                :class="{ 'error--text': hasErrors('company_city') }"
                                class="primary--text"
                                name="company_city"
                                label="Localitate"
                                data-vv-name="company_city"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="form.data.company_address"
                                v-validate="'required'"
                                :error-messages="errorMessages('company_address')"
                                :class="{ 'error--text': hasErrors('company_address') }"
                                class="primary--text"
                                name="company_address"
                                label="Adresa"
                                data-vv-name="company_address"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                v-model="form.data.company_address_no"
                                v-validate="'required'"
                                :error-messages="errorMessages('company_address_no')"
                                :class="{ 'error--text': hasErrors('company_address_no') }"
                                class="primary--text"
                                name="company_address_no"
                                label="Numar/Apartament"
                                data-vv-name="company_address_no"
                                counter="255"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-textarea
                                v-model="form.data.company_bank"
                                v-validate="'required'"
                                :error-messages="errorMessages('company_bank')"
                                :class="{ 'error--text': hasErrors('company_bank') }"
                                class="primary--text"
                                name="company_bank"
                                label="Conturi bancare"
                                data-vv-name="company_bank"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-textarea
                                v-model="form.data.company_phone"
                                v-validate="'required'"
                                :error-messages="errorMessages('company_phone')"
                                :class="{ 'error--text': hasErrors('company_phone') }"
                                class="primary--text"
                                name="company_phone"
                                label="Numere de telefon"
                                data-vv-name="company_phone"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-textarea
                                v-model="form.data.company_email"
                                v-validate="'required'"
                                :error-messages="errorMessages('company_email')"
                                :class="{ 'error--text': hasErrors('company_email') }"
                                class="primary--text"
                                name="company_email"
                                label="Adrese de e-mail"
                                data-vv-name="company_email"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.company_website"
                                :error-messages="errorMessages('company_website')"
                                :class="{ 'error--text': hasErrors('company_website') }"
                                class="primary--text"
                                name="company_website"
                                label="Adresa web"
                                data-vv-name="company_website"
                                counter="255"
                            />
                            <v-text-field
                                v-model="form.data.administrator_name"
                                :error-messages="errorMessages('administrator_name')"
                                :class="{ 'error--text': hasErrors('administrator_name') }"
                                class="primary--text"
                                name="administrator_name"
                                label="Nume administrator"
                                data-vv-name="administrator_name"
                                counter="255"
                            />
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-subheader>Setari de facturare</v-subheader>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                v-model="form.data.company_invoice_due"
                                :error-messages="errorMessages('data.company_invoice_due')"
                                :class="{ 'error--text': hasErrors('data.company_invoice_due') }"
                                class="primary--text"
                                name="data.company_invoice_due"
                                label="Scadenta facturi"
                                data-vv-name="data.company_invoice_due"
                                type="number"
                            />
                            <v-text-field
                                v-model="form.data.company_invoice_prefix"
                                :error-messages="errorMessages('data.company_invoice_prefix')"
                                :class="{ 'error--text': hasErrors('data.company_invoice_prefix') }"
                                class="primary--text"
                                name="data.company_invoice_prefix"
                                label="Serii de factura (mai multe valori, impartite cu virgula)"
                                data-vv-name="data.company_invoice_prefix"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-textarea
                                v-model="form.data.company_invoice_remarks"
                                :error-messages="errorMessages('data.company_invoice_remarks')"
                                :class="{ 'error--text': hasErrors('data.company_invoice_remarks') }"
                                class="primary--text"
                                name="data.company_invoice_remarks"
                                label="Observatii factura"
                                data-vv-name="data.company_invoice_remarks"
                            />
                        </v-col>
                    </v-row>
                </v-card>
            </v-tab-item>
            <v-tab-item key="settings">
                <v-card class="px-4 py-4" flat>
                    <v-row>
                        <v-col cols="4">
                            <v-text-field
                                v-model="form.data.vehicle_fuel_notification"
                                type="number"
                                v-validate="'required'"
                                :error-messages="errorMessages('data.vehicle_fuel_notification')"
                                :class="{ 'error--text': hasErrors('data.vehicle_fuel_notification') }"
                                class="primary--text"
                                name="data.vehicle_fuel_notification"
                                label="Statistici alimentari (zile)"
                                data-vv-name="data.vehicle_fuel_notification"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="form.data.vehicle_maintenance_notification"
                                type="number"
                                v-validate="'required'"
                                :error-messages="errorMessages('data.vehicle_maintenance_notification')"
                                :class="{ 'error--text': hasErrors('data.vehicle_maintenance_notification') }"
                                class="primary--text"
                                name="data.vehicle_maintenance_notification"
                                label="Statistici reparatii si revizii (zile)"
                                data-vv-name="data.vehicle_maintenance_notification"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="form.data.vehicle_expenses_notification"
                                type="number"
                                v-validate="'required'"
                                :error-messages="errorMessages('data.vehicle_expenses_notification')"
                                :class="{ 'error--text': hasErrors('data.vehicle_expenses_notification') }"
                                class="primary--text"
                                name="data.vehicle_expenses_notification"
                                label="Statistici impozite, RCA, ITP (zile)"
                                data-vv-name="data.vehicle_expenses_notification"
                            />
                        </v-col>
                    </v-row>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
        <v-card-actions>

            <v-btn
                :loading="form.busy"
                :disabled="errors.any() || form.busy"
                block
                color="success"
                @click="submit()"
            >
                Salveaza
                <v-icon right>
                    save
                </v-icon>
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";
    import swal from "sweetalert2";

    export default {
        mixins: [validationError],
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                name: null,
                data: {
                    company_name: null,
                    company_vat: null,
                    company_regcom: null,
                    company_authorization: null,
                    company_county: null,
                    company_city: null,
                    company_address: null,
                    company_address_no: null,
                    company_bank: null,
                    company_phone: null,
                    company_email: null,
                    company_website: null,
                    company_invoice_due: null,
                    company_invoice_prefix: null,
                    company_invoice_remarks: null,
                    administrator_name: null
                }
            }),
        }),
        watch: {
            'form.name': {
                handler(val) {
                    this.form.data.company_name = val
                }
            }
        },
        async mounted() {
            if(this.id) {
                await this.loadResources()
            }
        },
        methods: {
            async loadResources() {
                let self = this;
                this.loading = true;

                let { data } = await this.$db.Workstation.find(this.id)
                self.form = new Form(data)
                setTimeout(() => this.loading = false, 1000)
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.Workstation(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        self.$nextTick(() => self.$router.push({name: "admin-configuration-index"}));
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                        self.form.busy = false;
                    });
            }
        }
    };
</script>
